import styled, { css, keyframes } from 'styled-components';

export const Container = styled.div`
    margin-top: 5%;
    width: 100%;
    .wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 4px 0;
        border: 1px solid #aaa;
        width: 100%;
        .mission-label {
            padding-top: .5rem;
            padding-bottom: .5rem;
            font-size: 1.2rem;
            width: 35%;
            text-align: left;
            border-radius: 10px;
            font-weight: 500;
            text-transform: capitalize;
            border-radius: 0;
        }
        .mission-value {
            padding-top: .5rem;
            padding-bottom: .5rem;
            text-align: left;
            font-size: 1.2rem;
            width: 50%;
            padding-left: 5%;
        }
    }
    @media screen and (max-width: 600px) {
        overflow-y: auto;
        &::-webkit-scrollbar{
      width: 7px;
    }

    &::-webkit-scrollbar-track {
      box-shadow: inset 0 0 6px var(--light-blue);
      -webkit-box-shadow:  0 0 6px  transparent; 
      border-radius: 10px;
      max-height: 100px;
      height: 100%;

    }

    &::-webkit-scrollbar-thumb {
      box-shadow: inset 0 0 6px var(--light-blue);
      border-radius: 20px;
      -webkit-box-shadow: inset 40px 0 6px var(--light-blue); 
      max-height: 50px;
      height: 100%;
    }
        .wrapper {
            display: flex;
            flex-direction: column;
            border: 1px solid #aaa;
            padding-left: 16px;
            padding-right: 16px;
            align-items: flex-start;
        .mission-label {
            padding-top: .5rem;
            padding-bottom: .5rem;
            font-size: 1.2rem;
            width: 100%;
            text-align: left;
            border-radius: 10px;
            font-weight: 500;
            text-transform: capitalize;
            border-radius: 0;
            border-bottom: 1px solid #cccccc;
        }
        .mission-value {
            padding-left: 0;
            padding-top: .5rem;
            padding-bottom: .5rem;
            text-align: left;
            font-size: 1.2rem;
            width: 100%;
        }
    }
    }
`;